import letterhead from '@/views/mydiesel/letterheadkpdn.png'

const content = (registerForm, awamList, baranganList, oilcompanyList, dateFormatted, nextMonth) => {
  const vehicleContentA = []
  const vehicleContentB = []
  for (var awamIndex in awamList) {
    var vehicleA = awamList[awamIndex]
    vehicleContentA.push(`
      <tr>
        <td style="width: 5%;">${parseInt(awamIndex) + 1}.</td>
        <td style="width: 15%;">${vehicleA.vehicleNumber}</td>
        <td style="width: 15%;">${vehicleA.vehiclebodytypeId && vehicleA.vehiclebodytypeId.bodytypeSector ? vehicleA.vehiclebodytypeId.bodytypeSector === 'awam' ? 'AWAM' : vehicleA.vehiclebodytypeId.bodytypeSector === 'barangan' ? 'BARANGAN' : vehicleA.vehiclebodytypeId.bodytypeSector : '-'}</td>
        <td style="width: 25%;">${vehicleA.vehicleBodyTypeName ? `${vehicleA.vehicleBodyTypeCode ? `(${vehicleA.vehicleBodyTypeCode}) - ` : ''}${vehicleA.vehicleBodyTypeName}` : '-'}</td>
        <td style="width: 30%;">${vehicleA.vehicleModelTypeName ? `${vehicleA.vehicleModelTypeCode ? `(${vehicleA.vehicleModelTypeCode}) - ` : ''}${vehicleA.vehicleModelTypeName}` : '-'}</td>
        <td style="width: 10%;">${vehicleA.vehicleRoadTaxEndDate ? vehicleA.vehicleRoadTaxEndDate : '-'}</td>
      </tr>
    `)
  }
  for (var baranganIndex in baranganList) {
    var vehicleB = baranganList[baranganIndex]
    vehicleContentB.push(`
      <tr>
        <td style="width: 5%;">${parseInt(baranganIndex) + 1}.</td>
        <td style="width: 15%;">${vehicleB.vehicleNumber}</td>
        <td style="width: 15%;">${vehicleB.vehiclebodytypeId && vehicleB.vehiclebodytypeId.bodytypeSector ? vehicleB.vehiclebodytypeId.bodytypeSector === 'awam' ? 'AWAM' : vehicleB.vehiclebodytypeId.bodytypeSector === 'barangan' ? 'BARANGAN' : vehicleB.vehiclebodytypeId.bodytypeSector : '-'}</td>
        <td style="width: 25%;">${vehicleB.vehicleBodyTypeName ? `${vehicleB.vehicleBodyTypeCode ? `(${vehicleB.vehicleBodyTypeCode}) - ` : ''}${vehicleB.vehicleBodyTypeName}` : '-'}</td>
        <td style="width: 30%;">${vehicleB.vehicleModelTypeName ? `${vehicleB.vehicleModelTypeCode ? `(${vehicleB.vehicleModelTypeCode}) - ` : ''}${vehicleB.vehicleModelTypeName}` : '-'}</td>
        <td style="width: 10%;">${vehicleB.vehicleRoadTaxEndDate ? vehicleB.vehicleRoadTaxEndDate : '-'}</td>
      </tr>
    `)
  }
  return `
<!DOCTYPE html>
<html>
<head>
<style>
  body {
    margin: 0px;
  }

  .backgroundImage {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 210mm;
    z-index: -999;
  }

  .parent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 210mm;
    height: 297mm;
    position: relative;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: visible;
    width: 159.2mm;
    height: 20mm;
    margin-top: 25.4mm;
  }

  .letterhead {
    display: flex;
    width: 159mm;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 216.2mm;
    margin-top: 10mm;
  }

  .content2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 246.2mm;
    margin-top: 25.4mm;
  }

  p {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
  }

  .pright{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .prightopacity{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 23px;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    opacity: 0.2;
    width: 100%;
  }

  .prightsmallfont{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 3mm;
    font-style: bold;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .pjustify {
    text-align: justify;
  }

  .pmarginleft{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    margin-left: 10px;
    line-height: 4mm;
  }

  .ptitle {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: center;
    width: 100%;
    color: var(--v4-login-button);
    font-weight: bold;
  }

  .hline {
    width: 100%;
    height: 2px;
    border-top: 1px black solid;
  }

  /* dev colors */
  .page1 {
  }
  .page2 {
  }

  table, th, td {
    border: 1px solid grey;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: center;
    border-collapse: collapse;
  }
</style>
</head>
<body>
  <div class="parent page1">
    <div class="header">
      <img id="letterhead" class="letterhead" src="${letterhead}"/>
    </div>
    <div class="content">
      <div class="ptitle">
        <p>SENARAI KENDERAAN YANG LAYAK BERMULA ${nextMonth}</p><br>
      </div>
      <p style="color: blue"><b>${registerForm.userGeneralName}</b> </p>
      ${vehicleContentA.length > 0 ? `
        <p style="margin-top: 10px;">AWAM</p>
        <table style="width: 100%;">
          <tr>
            <th>NO.</th>
            <th>NO. PENDAFTARAN</th>
            <th>SEKTOR PENGANGKUTAN</th>
            <th>PENGGUNAAN KELAS</th>
            <th>JENIS PENGGUNAAN</th>
            <th>TARIKH LUPUT CUKAI JALAN</th>
          </tr>
          ${vehicleContentA.join('')}
        </table>
        ` : ''
      }
      ${vehicleContentB.length > 0 ? `
        <p style="margin-top: 10px;">BARANGAN</p>
        <table style="width: 100%;">
          <tr>
            <th>NO.</th>
            <th>NO. PENDAFTARAN</th>
            <th>SEKTOR PENGANGKUTAN</th>
            <th>PENGGUNAAN KELAS</th>
            <th>JENIS PENGGUNAAN</th>
            <th>TARIKH LUPUT CUKAI JALAN</th>
          </tr>
          ${vehicleContentB.join('')}
        </table>
        ` : ''
      }
      <div class="prightsmallfont">
        <p style="font-size: 10px; font-weight: bold; margin-top: 5px;">*Surat cetakan komputer ini tidak memerlukan sebarang tandatangan</p><br>
      </div>
    </div>
  </div>
</body>
</html>`
}
export default {
  content
}


// WEBPACK FOOTER //
// ./src/views/mydiesel/suratsenaraikenderaan.js